export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";